export enum BonusGameWinnerEnum {
  VISITOR = 1,
  HOME = 2,
}

export enum BonusTeamEnumEnum {
  VISITOR = 1,
  HOME = 2,
}
